// Imports
var ___CSS_LOADER_API_SOURCEMAP_IMPORT___ = require("../../../../../node_modules/css-loader/dist/runtime/sourceMaps.js");
var ___CSS_LOADER_API_IMPORT___ = require("../../../../../node_modules/css-loader/dist/runtime/api.js");
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.blockWrapper__QBAkR {
  box-shadow: var(--modal-box-shadow);
}

.equipmentTypeItem__ckfQN:not(:first-child) {
  border-top: 1px solid var(--tables-primary-row-stroke);
}

.accordionSkeletonBlock__k5HvA {
  display: flex;
  align-items: center;
  column-gap: 5px;
  padding: 14.5px 25px;
  background-color: var(--tables-primary-row-surface-default);
}

.arrow__I7JIg path {
  stroke: var(--tables-primary-row-icon);
}

.areaWrapper__clVfZ {
  display: flex;
  flex-wrap: wrap;
  gap: 15px;
}
.areaWrapper__clVfZ:has(div) {
  padding-bottom: 15px;
}

.skeletonText__CLtAX {
  width: 100%;
  height: 12px;
}`, "",{"version":3,"sources":["webpack://./../src/pages/HardwareOverviewDetails/components/HardwareOverviewDetailsBlock/style.module.scss"],"names":[],"mappings":"AA0EA;EACE,mCAAA;AAzEF;;AA6EE;EACE,sDAAA;AA1EJ;;AA8EA;EACE,aAAA;EACA,mBAAA;EACA,eAAA;EACA,oBAAA;EACA,2DAAA;AA3EF;;AA+EE;EACE,sCAAA;AA5EJ;;AAgFA;EACE,aAAA;EACA,eAAA;EACA,SAAA;AA7EF;AA+EE;EACE,oBAAA;AA7EJ;;AAiFA;EACE,WAAA;EACA,YAAA;AA9EF","sourcesContent":["%scrollbar-style {\n  scrollbar-color: rgba(0, 0, 0, 0.2) rgba(0, 0, 0, 0.05);\n  scrollbar-width: auto;\n\n  &::-webkit-scrollbar {\n    width: 6px;\n    height: 6px;\n    border-radius: 3px;\n  }\n\n  &::-webkit-scrollbar-track {\n    background: rgba(0, 0, 0, 0.05);\n    border-radius: 3px;\n  }\n\n  &::-webkit-scrollbar-thumb {\n    background: rgba(0, 0, 0, 0.2);\n    border-radius: 3px;\n  }\n\n  &::-webkit-scrollbar-thumb:hover {\n    background: #888;\n    border-radius: 3px;\n  }\n}\n@mixin scrollBar {\n  &::-webkit-scrollbar {\n    width: 6px;\n    height: 6px;\n    border-radius: 3px;\n  }\n\n  &::-webkit-scrollbar-track {\n    background: rgba(0, 0, 0, 0.05);\n    border-radius: 3px;\n  }\n\n  &::-webkit-scrollbar-thumb {\n    background: rgba(0, 0, 0, 0.2);\n    border-radius: 3px;\n  }\n\n  &::-webkit-scrollbar-thumb:hover {\n    background: #888;\n    border-radius: 3px;\n  }\n}\n\n@mixin ellipsis-text {\n  overflow: hidden;\n  text-overflow: ellipsis;\n  white-space: pre-wrap;\n  word-wrap: break-word;\n  display: -webkit-box;\n  -webkit-box-orient: vertical;\n}\n\n@mixin tooltip {\n  padding: 8px !important;\n  opacity: 1 !important;\n  filter: drop-shadow(0 0 1px rgba(12, 26, 75, 0.24));\n  border-radius: 4px !important;\n  text-align: left !important;\n}\n\n@mixin modalTitle {\n  color: var(--header-title-main);\n  font-size: 18px;\n  font-style: normal;\n  font-weight: 500;\n  line-height: 20px;\n  text-transform: uppercase;\n}\n\n.blockWrapper {\n  box-shadow: var(--modal-box-shadow);\n}\n\n.equipmentTypeItem {\n  &:not(:first-child) {\n    border-top: 1px solid var(--tables-primary-row-stroke);\n  }\n}\n\n.accordionSkeletonBlock {\n  display: flex;\n  align-items: center;\n  column-gap: 5px;\n  padding: 14.5px 25px;\n  background-color: var(--tables-primary-row-surface-default);\n}\n\n.arrow {\n  path {\n    stroke: var(--tables-primary-row-icon);\n  }\n}\n\n.areaWrapper {\n  display: flex;\n  flex-wrap: wrap;\n  gap: 15px;\n\n  &:has(div) {\n    padding-bottom: 15px;\n  }\n}\n\n.skeletonText {\n  width: 100%;\n  height: 12px;\n}\n"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {
	"blockWrapper": `blockWrapper__QBAkR`,
	"equipmentTypeItem": `equipmentTypeItem__ckfQN`,
	"accordionSkeletonBlock": `accordionSkeletonBlock__k5HvA`,
	"arrow": `arrow__I7JIg`,
	"areaWrapper": `areaWrapper__clVfZ`,
	"skeletonText": `skeletonText__CLtAX`
};
module.exports = ___CSS_LOADER_EXPORT___;
